
import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { MaterielEau } from "./materiel-eau";

export class MeasureEau {
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingId!: number;
    @AutoMap()
    SamplingTime?: Temporal.PlainTime;
    @AutoMap()
    Localisation?: string;
    @AutoMap()
    MaterielEau!: MaterielEau;
    @AutoMap()
    SampleCode?: string;

    public constructor(init?: Partial<MeasureEau>) {
        Object.assign(this, init);
    }
}